module.exports = __webpack_public_path__ + "static/media/adskicon-rosetta-512.d381fcc5.pxm";